interface ColorCirclesProps {
  colors: string[];
  size?: string;
  overlap?: string;
}

export const ColorCircles = ({
  colors,
  size = "w-4 h-4",
  overlap = "-ml-1.5" // Default overlap amount
}: ColorCirclesProps) => {
  return (
    <div className="flex flex-row">
      {colors.map((color, index) => (
        <div 
          key={`${color}-${index}`} 
          className={`${size} rounded-full ${index !== 0 ? overlap : ''}`}
          style={{ backgroundColor: color }} 
        />
      ))}
    </div>
  );
}; 